function setupWishlistButton(button) {

  const handle = button.dataset.productHandle;
  const data = button.dataset;
  if (!handle) return;

  let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

  if (wishlist.includes(handle)) {
    button.classList.add('active');
  }

  // Prevent duplicate event listeners
  if (!button.dataset.wishlistInitialized) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter(item => item !== handle);
        button.classList.remove('active');
      } else {
        wishlist.push(handle);
        button.classList.add('active');
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    });

    // Mark as initialized to avoid re-binding
    button.dataset.wishlistInitialized = "true";
  }
}

function initWishlistButtons() {
  document.querySelectorAll('.wishlist-button').forEach(setupWishlistButton);
}

document.addEventListener('DOMContentLoaded', initWishlistButtons);
document.addEventListener('shopify:section:load', initWishlistButtons);

// 👇 Observe dynamic DOM changes
const observer = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) { // Element node
        if (node.classList?.contains('wishlist-button')) {
          setupWishlistButton(node);
        } else {
          // Search inside nested elements
          node.querySelectorAll?.('.wishlist-button').forEach(setupWishlistButton);
        }
      }
    });
  }
});

observer.observe(document.body, { childList: true, subtree: true });